// TokenManager.js
export async function tokenManager(token, logoutCallback) {
    if (!token) {
        logoutCallback();
        return;
    }

    try {
        const response = await fetch(`https://oauth2.googleapis.com/tokeninfo?id_token=${token}`);
        if (response.ok) {
            const data = await response.json();
            if (data.aud === "123082628380-40ls2ohk6j786nnrnoskpeli0mf82b9a.apps.googleusercontent.com") {
                console.log('Token Reverified')
            } else {
                logoutCallback();
            };
        } else {
            console.log("running in response not ok ")
            logoutCallback();
        }
    } catch (error) {

        logoutCallback();
    }
}
